import client from "./client.js";

// Channels
export async function listChannels() {
  const res = await client.get("/channels");
  return res.data.data;
}

export async function createChannel(body) {
  const res = await client.post("/channels", body);
  return res.data.data;
}

export async function getChannel(id) {
  const res = await client.get(`/channels/${id}`);
  return res.data.data;
}

export async function updateChannel(id, body) {
  const res = await client.put(`/channels/${id}`, body);
  return res.data.data;
}

export async function deleteChannel(id) {
  await client.delete(`/channels/${id}`);
}

export async function addChannelMember(channelId, userId) {
  const res = await client.post(`/channels/${channelId}/members`, { user_id: userId });
  return res.data.data;
}

export async function removeChannelMember(channelId, userId) {
  await client.delete(`/channels/${channelId}/members/${userId}`);
}

// Notification preferences (current user)
export async function getMyNotificationPreferences() {
  const res = await client.get("/users/me/notification-preferences");
  return res.data.data;
}

export async function updateMyNotificationPreferences(body) {
  const res = await client.put("/users/me/notification-preferences", body);
  return res.data.data;
}

// Channel endpoints
export async function addChannelEndpoint(channelId, data) {
  const res = await client.post(`/channels/${channelId}/endpoints`, data);
  return res.data.data;
}

export async function removeChannelEndpoint(channelId, endpointId) {
  await client.delete(`/channels/${channelId}/endpoints/${endpointId}`);
}

export async function testChannel(channelId) {
  const res = await client.post(`/channels/${channelId}/test`);
  return res.data.data;
}

export async function fetchChannelDeliveries(channelId, limit = 20) {
  const res = await client.get(`/channels/${channelId}/deliveries`, { params: { limit } });
  return res.data.data;
}

// Monitor channel assignment
export async function getMonitorChannels(monitorId) {
  const res = await client.get(`/monitors/${monitorId}/channels`);
  return res.data.data;
}

export async function setMonitorChannels(monitorId, channelIds) {
  const res = await client.put(`/monitors/${monitorId}/channels`, { channel_ids: channelIds });
  return res.data.data;
}
